import { useSentryWalletInit } from 'utils/useSentryWalletInit'

export function WalletSentryInit() {
  useSentryWalletInit()
  return null
}
